import styled from 'styled-components';

import { Input } from '@xsolla/ui-core';

export const IsShowModeButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CustomizingInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const ValueLength = styled.div`
  position: absolute;
  bottom: 5px;
  right: 20px;
  font-size: 15px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
`;

export const CustomizeProjectNameInput = styled(Input)`
  padding: 3px 80px 3px 12px;
  font-size: 15px;
  line-height: 24px;
  border-radius: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const CustomizeProjectNameForm = styled.form`
  display: flex;
  align-items: center;
`;

export const ProjectName = styled.div`
  font-size: 22px;
  line-height: 32px;
  margin-right: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media only screen and (max-width: 1100px) and (min-width: 980px) {
    max-width: 300px;
  }
`;

export const NavigationInputWrapper = styled.div`
  position: relative;
`;

export const ValidationMessageWrapper = styled.div`
  position: absolute;
`;
